import { render, staticRenderFns } from "./metarialPublish.vue?vue&type=template&id=628ea879"
import script from "./metarialPublish.vue?vue&type=script&lang=js"
export * from "./metarialPublish.vue?vue&type=script&lang=js"
import style0 from "./metarialPublish.vue?vue&type=style&index=0&id=628ea879&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports